/**
 * @generated SignedSource<<7a0619e0618d0f612b7b56f5fd03dac6>>
 * @relayHash 174dfd62fb50a2a7dcdfdfa25c33ef4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 465e18c29b80899568ed74ff08be9f9efe10e3a3efad0f0a92c504f3b8f10895

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraReleasesEpicReleaseStatusFilter = "RELEASED" | "RELEASED_AND_UNRELEASED" | "%future added value";
export type JiraReleasesEpicFilter = {
  projectId: string;
  releaseStatusFilter?: JiraReleasesEpicReleaseStatusFilter | null | undefined;
  text?: string | null | undefined;
};
export type getEpicsRelayQuery$variables = {
  filter: JiraReleasesEpicFilter;
  first: number;
};
export type getEpicsRelayQuery$data = {
  readonly jiraReleases: {
    readonly epics: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly summary: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type getEpicsRelayQuery = {
  response: getEpicsRelayQuery$data;
  variables: getEpicsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "concreteType": "JiraReleases",
    "kind": "LinkedField",
    "name": "jiraReleases",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "JiraReleasesEpicConnection",
        "kind": "LinkedField",
        "name": "epics",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraReleasesEpic",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "summary"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getEpicsRelayQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getEpicsRelayQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "465e18c29b80899568ed74ff08be9f9efe10e3a3efad0f0a92c504f3b8f10895",
    "metadata": {},
    "name": "getEpicsRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c0f3b27fa6a0d9bd173b6183209bae4";

export default node;
